import React, { useState, useEffect, useCallback } from 'react'
import { Button, Card, Checkbox } from 'react-daisyui'
import { API } from '../../utils/api'
import { Api } from '../../utils/apiServer'
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import { AiOutlineShoppingCart, AiOutlineDelete, AiOutlineMinus, AiOutlinePlus } from "react-icons/ai"
import ShoppingSummary from '../../components/ShoppingSummary'
import DefaultProduct from "../../assets/default-product.jpg"
import { auth } from '../../utils/AuthSession'

function Cart() {
    const [authUser, setAuthUser] = useState()
    const [cartItems, setCartItems] = useState([])
    const [loading, setLoading] = useState(true)
    const [total, setTotal] = useState(0)
    const [itemCount, setItemCount] = useState(0)

    const navigate = useNavigate()

    const calculateTotal = useCallback(() => {
        let totalAmount = 0
        let count = 0
        for (const item of cartItems) {
            if (item.checked === '1') {
                const subtotal = item.current_price * item.quantity
                totalAmount += subtotal
                count++
            }
        }
        setTotal(totalAmount)
        setItemCount(count)
    }, [cartItems])

    const loadCart = useCallback(async (member_id, partner_id) => {
        setLoading(true)
        const params = {
            access: 'auth',
                method: API.CART.type,
                url: API.CART.url,
                reqBody: {
                    page: 1,
                    rows: 1000,
                    filter: [
                      {
                        field: "member_id",
                        operator: "=",
                        value: member_id
                      },
                      {
                        field: "partner_id",
                        operator: "=",
                        value: partner_id
                    }
                    ]
                }
        }
        try {
            const response = await Api(params)
            if (response.status) {
                setCartItems(response.data.data)
            } else {
                toast.error(response.message)
            }
        } catch (error) {
            toast.error('Terjadi kesalahan saat memuat keranjang')
        } finally {
            setLoading(false)
        }
    }, [])

    const loadAuthAndCart = useCallback(async () => {
        try {
            const authData = await auth()
            setAuthUser(authData)
            if (authData?.data?.member_id && authData?.data?.partner_id) {
                await loadCart(authData.data.member_id, authData.data.partner_id)
            }
        } catch (error) {
            toast.error('Terjadi kesalahan saat memuat data')
        }
    }, [loadCart])

    useEffect(() => {
        loadAuthAndCart()
    }, [loadAuthAndCart])

    useEffect(() => {
        calculateTotal()
    }, [calculateTotal])

    



    const updateCart = async (d) => {
        const params = {
            access: 'auth',
            method: API.EDIT_CART.type,
            url: API.EDIT_CART.url,
            reqBody: {
                cart_id: d.cart_id,
                item_id: d.item_id,
                quantity: d.quantity
            }
        }
        try {
            const response = await Api(params)
            if (!response.status) {
                toast.error(response.message)
            }
        } catch (error) {
            toast.error(error.message)
        }

    }

    const deleteCart = async (d) => {
        const params = {
            access: 'auth',
            method: API.DELETE_CART.type,
            url: API.DELETE_CART.url,
            reqBody: {
                cart_id: d.cart_id,
            }
        }
        try {
            const response = await Api(params)
            if (!response.status) {
                toast.error(response.message)
            } else {
                // Reload cart after successful update
                if (authUser?.data?.member_id && authUser?.data?.partner_id) {
                    await loadCart(authUser.data.member_id, authUser.data.partner_id)
                }
            }
        } catch (error) {
            toast.error(error.message)
        }

    }

    const handleIncreaseQty = async (item, index) => {
        const newQuantity = item.quantity < item.menu_current_quantity ? item.quantity + 1 : item.menu_current_quantity

        const updatedItems = [...cartItems]
        updatedItems[index].quantity = newQuantity
        setCartItems(updatedItems)

        await updateCart(updatedItems[index])
    }

    const handleChangeQty = async (e, item, index) => {
        const newQuantity = Math.min(Math.max(0, parseInt(e.target.value) || 0), item.menu_current_quantity)

        const updatedItems = [...cartItems]
        updatedItems[index].quantity = newQuantity
        setCartItems(updatedItems)

        await updateCart(updatedItems[index])
    }

    const handleToggleChecked = async (item, index) => {
        const newChecked = item.checked === '0' ? '1' : '0'

        const params = {
            access: 'auth',
            method: API.EDIT_CART.type,
            url: API.EDIT_CART.url,
            reqBody: {
                cart_id: item.cart_id,
                checked: newChecked
            }
        }
        try {
            const response = await Api(params)
            if (!response.status) {
                toast.error(response.message)
            } else {
                // Reload cart to get updated data
                if (authUser?.data?.member_id && authUser?.data?.partner_id) {
                    await loadCart(authUser.data.member_id, authUser.data.partner_id)
                }
            }
        } catch (error) {
            toast.error('Terjadi kesalahan saat memperbarui item')
        }
    }

    const handleBuyClick = () => {
        navigate('/order')
    }

    const handleDeleteItem = async (item) => {
        const params = {
            access: 'auth',
            method: API.DELETE_CART.type,
            url: API.DELETE_CART.url,
            reqBody: {
                cart_id: item.cart_id,
            }
        }
        try {
            const response = await Api(params)
            if (!response.status) {
                toast.error(response.message)
            } else {
                toast.success('Item berhasil dihapus dari keranjang')
                // Reload cart
                if (authUser?.data?.member_id && authUser?.data?.partner_id) {
                    await loadCart(authUser.data.member_id, authUser.data.partner_id)
                }
            }
        } catch (error) {
            toast.error('Terjadi kesalahan saat menghapus item')
        }
    }

    // Loading skeleton component
    const LoadingSkeleton = () => (
        <div className="animate-pulse space-y-4">
            <div className="bg-gray-200 h-8 rounded w-1/3 mx-auto"></div>
            <div className="space-y-3">
                {[...Array(3)].map((_, i) => (
                    <div key={i} className="bg-gray-200 h-32 rounded-lg"></div>
                ))}
            </div>
        </div>
    )

    if (loading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
                <div className="mx-auto max-w-sm px-5 py-6">
                    <LoadingSkeleton />
                </div>
            </div>
        )
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
            <ToastContainer autoClose={1000} />
            <div className="mx-auto max-w-sm px-5 py-6">
                <div className='flex flex-col space-y-6 scrollbar-hide'>

                    {/* Header Section */}
                    <div className="text-center space-y-2">
                        <div className="flex items-center justify-center space-x-2">
                            <AiOutlineShoppingCart className="text-2xl text-blue-600" />
                            <h1 className="text-2xl font-bold text-gray-800">Keranjang Belanja</h1>
                        </div>
                        <p className="text-gray-600 text-sm">
                            {cartItems.length > 0 ? `${cartItems.length} item dalam keranjang` : 'Keranjang Anda kosong'}
                        </p>
                    </div>

                    {cartItems.length === 0 ? (
                        <Card className="bg-gradient-to-r from-gray-50 to-white border-2 border-dashed border-gray-300">
                            <Card.Body className="text-center py-12">
                                <AiOutlineShoppingCart className="text-6xl text-gray-400 mx-auto mb-4" />
                                <p className="text-gray-500 font-medium text-lg">Keranjang Anda kosong</p>
                                <p className="text-gray-400 text-sm mt-1">Tambahkan produk ke keranjang untuk melanjutkan</p>
                                <Button
                                    className="bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white border-none mt-4"
                                    onClick={() => navigate('/product')}
                                >
                                    Mulai Belanja
                                </Button>
                            </Card.Body>
                        </Card>
                    ) : (
                        <div className="space-y-4">
                            {/* Cart Items */}
                            <div className="space-y-3">
                                {cartItems.map((item, i) => (
                                    <Card key={i} className="bg-white shadow-lg hover:shadow-xl transition-all duration-300 border-0 overflow-hidden">
                                        <Card.Body className="p-0">
                                            <div className="p-4">
                                                <div className="flex items-start space-x-3">
                                                    {/* Checkbox */}
                                                    <div className="flex-shrink-0 mt-1">
                                                        <Checkbox
                                                            size="lg"
                                                            checked={item.checked === '1'}
                                                            onChange={() => handleToggleChecked(item, i)}
                                                            className="checkbox-primary"
                                                        />
                                                    </div>

                                                    {/* Product Image */}
                                                    <div className="flex-shrink-0">
                                                        <img
                                                            src={item.item_image || DefaultProduct}
                                                            alt={item.item_name}
                                                            className="w-16 h-16 rounded-lg object-cover shadow-sm"
                                                            onError={(e) => {
                                                                e.target.src = DefaultProduct
                                                            }}
                                                        />
                                                    </div>

                                                    {/* Product Details */}
                                                    <div className="flex-1 min-w-0">
                                                        <h3 className="font-semibold text-gray-800 text-sm leading-tight line-clamp-2">
                                                            {item.item_name}
                                                        </h3>
                                                        <p className="text-red-500 text-xs mt-1">
                                                            Stok tersisa: {item.menu_current_quantity}
                                                        </p>
                                                        <p className="text-lg font-bold text-green-600 mt-1">
                                                            Rp {Intl.NumberFormat('en-ID').format(item.current_price)}
                                                        </p>
                                                    </div>

                                                    {/* Delete Button */}
                                                    <Button
                                                        size="sm"
                                                        variant="ghost"
                                                        className="text-red-500 hover:bg-red-50 hover:text-red-600 p-2 flex-shrink-0"
                                                        onClick={() => handleDeleteItem(item)}
                                                    >
                                                        <AiOutlineDelete className="text-lg" />
                                                    </Button>
                    </div>

                                                {/* Quantity Controls */}
                                                <div className="flex items-center justify-between mt-4 pt-3 border-t border-gray-100">
                                                    <div className="text-sm text-gray-600">
                                                        Kuantitas:
                                    </div>
                                                    <div className="flex items-center space-x-2">
                                                        <Button
                                                            size="sm"
                                                            variant="outline"
                                                            className="w-8 h-8 p-0 border-gray-300 hover:bg-gray-50"
                                                            onClick={() => handleIncreaseQty(item, i)}
                                                            disabled={item.quantity >= item.menu_current_quantity}
                                                        >
                                                            <AiOutlineMinus className="text-sm" />
                                                        </Button>
                                                        <input
                                                            type="number"
                                                            className="input input-bordered input-sm w-16 text-center"
                                                            value={item.quantity}
                                                            onChange={(e) => handleChangeQty(e, item, i)}
                                                            min="0"
                                                            max={item.menu_current_quantity}
                                                        />
                                                        <Button
                                                            size="sm"
                                                            variant="outline"
                                                            className="w-8 h-8 p-0 border-gray-300 hover:bg-gray-50"
                                                            onClick={() => handleIncreaseQty(item, i)}
                                                        >
                                                            <AiOutlinePlus className="text-sm" />
                                                        </Button>
                                        </div>
                                    </div>
                                </div>
                                        </Card.Body>
                                    </Card>
                        ))}
                    </div>

                            {/* Shopping Summary */}
                            <div className="sticky bottom-0 bg-white border-t border-gray-200 p-4 rounded-t-lg shadow-lg">
                                <ShoppingSummary
                                    total={total}
                                    count={itemCount}
                                    onClick={handleBuyClick}
                                />
                    </div>
                </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Cart